<template>
  <div class="pa-2">
    <div class="d-flex justify-center">
      <router-link to="/" class="d-flex justify-center">
        <img alt="WTF Logo" class="fmi_logo" src="../../assets/wtf-logo.jpg" />
      </router-link>
    </div>

    <ChallengesResultsLinks></ChallengesResultsLinks>
    <v-divider class="mt-3"></v-divider>
    <LoopsResultsLinks></LoopsResultsLinks>
    <div class="d-flex flex-column justify-center align-center mt-5">
      <p style="font-size: 12px">
        <b>Générée par</b>
      </p>
      <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png"
          style="display: inline; width: 80px" /></a>
    </div>
  </div>
</template>

<script>
import ChallengesResultsLinks from "@/components/App/ChallengesResultsLinks.vue";
import LoopsResultsLinks from "@/components/App/LoopsResultsLinks.vue";
export default {
  name: "NavigationDrawer",
  components: {
    ChallengesResultsLinks,
    LoopsResultsLinks,
  },
};
</script>

<style lang="scss" scoped>
.fmi_logo {
  width: min(100%, 150px);
  height: auto;
}
</style>